/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_No_Segments_ToastInputs */

const en_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to segment Event Group. Please insert segments.`)
};

const fr_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de segmenter le groupe d'evenements. Veuillez inserer des segments.`)
};

const de_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisgruppe konnte nicht segmentiert werden. Bitte fügen Sie Segmente ein.`)
};

const it_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile segmentare il gruppo di eventi. Inserire i segmenti.`)
};

const ru_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось выделить группу событий. Пожалуйста, добавьте сегменты.`)
};

const es_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede segmentar el grupo de eventos. Inserte segmentos.`)
};

const zh_cn2_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法对事件组进行分段。请插入分段。`)
};

const ja_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループをセグメント化できません。セグメントを挿入してください。`)
};

const hi_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप को सेगमेंट करने में असमर्थ। कृपया सेगमेंट डालें।`)
};

const pt_pt2_segment_event_group_no_segments_toast = /** @type {(inputs: Segment_Event_Group_No_Segments_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível segmentar o Grupo de Eventos. Insira os segmentos.`)
};

/**
* | output |
* | --- |
* | "Unable to segment Event Group. Please insert segments." |
*
* @param {Segment_Event_Group_No_Segments_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_no_segments_toast = /** @type {((inputs?: Segment_Event_Group_No_Segments_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_No_Segments_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_no_segments_toast(inputs)
	if (locale === "de") return de_segment_event_group_no_segments_toast(inputs)
	if (locale === "it") return it_segment_event_group_no_segments_toast(inputs)
	if (locale === "ru") return ru_segment_event_group_no_segments_toast(inputs)
	if (locale === "es") return es_segment_event_group_no_segments_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_no_segments_toast(inputs)
	if (locale === "ja") return ja_segment_event_group_no_segments_toast(inputs)
	if (locale === "hi") return hi_segment_event_group_no_segments_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_no_segments_toast(inputs)
	return en_segment_event_group_no_segments_toast(inputs)
});